import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { NotificationPanelComponent } from './notification-panel.component';
import { Notification } from './notification.model';
import { NotificationService } from './notification.service';

@Injectable()
export class NotificationPanelService {
    private _panel: NotificationPanelComponent;
    toggle: EventEmitter<boolean>;
    notifications: Notification[];
    notificationChange: EventEmitter<Notification[]>;

    constructor(private readonly _notificationService: NotificationService) {
        this.toggle = new EventEmitter<boolean>();
        this.notificationChange = new EventEmitter<Notification[]>();
    }

    get isOpen(): boolean {
        return !this._panel ? false : this._panel.open;
    }

    register(panel: NotificationPanelComponent): void {
        this._panel = panel;
    }

    toggleOpenState(): void {
        if (!this._panel) return;
        this._panel.open = !this._panel.open;
    }

    reload(forceReload: boolean): Observable<any> {
        if (!this._panel) return;
        return this._panel.load(forceReload);
    }

    get unAcknowledged(): Notification[] {
        return this.notifications == null
            ? []
            : this.notifications.filter((value) => !value.wasAcknowledged);
    }

    markAsAcknowledged(notification: Notification): void {
        if (notification.wasAcknowledged) return;
        notification.acknowledgedOn = new Date();
        this._notificationService
            .updateAcknowledgeOn(notification)
            .subscribe((success) => {
                // if (!success) return; //TODO revise. not waiting
                // api doesn't return updated notification
                // notification.acknowledgedOn = new Date();
                notification.wasAcknowledged = true;
                this.notificationChange.emit([notification]);
            });
    }

    markAsRead(notification: Notification): void {
        if (notification.wasRead) return;
        notification.readOn = new Date();
        this._notificationService
            .updateReadOn(notification)
            .subscribe((success) => {
                // if (!success) return; //TODO revise. not waiting
                // api doesn't return updated notification
                // notification.readOn = new Date();
                notification.wasRead = true;
                this.notificationChange.emit([notification]);
            });
    }
}
